import styled from 'styled-components';

export const VoicebotInstanceWrapper = styled.div`
  .button-create {
    cursor: pointer;
    margin: 12px 0;
  }
`;

export const VoicebotInstanceList = styled.ul`
  margin: 0 0 24px;
  padding: 0;
`;

export const VoicebotInstance = styled.li`
  list-style: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  .info {
    display: flex;
    flex-direction: column;
  }

  .name {
    color: #515f75;
    font-size: 16px;
    font-weight: 500;
  }

  .base-url {
    color: #999999;
    font-size: 14px;
  }

  button {
    border-radius: 11px;
    background-color: #515f75;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    padding: 0 0.75rem;
    margin-right: 12px;
    outline: none;
    height: 22px;
    border: none;

    &:hover {
      background-color: #6e7e94;
    }
  }
`;

export const ModalInstanceWrapper = styled.div`
  .modal-instance__title {
    font-size: 18px;
    color: #515f75;
    margin-bottom: 12px;
  }

  .modal-instance__form-group {
    label {
      font-size: 13px;
      margin-bottom: 4px;
    }

    input {
      border: 0;
      background: #f2f2f2 0% 0% no-repeat padding-box;
      border-radius: 5px;
      font-size: 13px;
    }
  }
`;
